'use strict';

// 核心
import React from 'react';
import {EventEmitter} from 'events';
import classnames from 'classnames'

//
import Component from '../core/component';
import Enhance from '../core/enhance';
import tools from '../libs/tools';

// 组件
import Handler from './handler';


/**
 *
 */
class Switch extends Component {
    state = {
        current: {},
        prev: {},
        last: {}
    }

    constructor(props, context) {
        super(props, context);
        this.state.check = ~~this.props.default;
    }

    /**
     * componentDidUpdate(object prevProps, object prevState)在更新发生之后调用。
     */
    componentDidUpdate(prevProps, prevState) {
    }


    render() {
        return (<div className={this.props.className}>{this.renderSwitch()}</div>);
    }


    /**
     * 检查切换
     * @returns {*}
     * @private
     */
    renderSwitch() {
        var data = Handler.queryData();
        this.state.check = data[this.props.search] || this.state.check;
        // console.log(this.state);
        if (this.props.type == 'active') {
            let views = [];
            if ($.isArray(this.props.children)) {
                $.each(this.props.children, (i, item) => {
                    var view = React.cloneElement(item, {
                        className: classnames(item.props.className, {'active': this.state.check == i}),
                        active: this.state.check == i
                    })
                    views.push(view);
                });
            }
            return views;
        } else {
            if ($.isArray(this.props.children)) {
                let views = [];
                $.each(this.props.children, (i, item) => {
                    if (item.key == this.state.check) {
                        var view = React.cloneElement(item, {
                            className: classnames(item.props.className, {'active': this.state.check == i}),
                            active: true
                        });
                        views.push(view);
                        return false;
                    }
                });
                return views;
            }
        }
    }
}

export default Enhance(Switch, {}, 'Switch');